<template>
	<sidebar_menu
		@change_side_bar_value="openCloseMenu($event)"
		id="sidebar-element"
		class="sidebar-menu" />
	<sidebar_menu_mobile />
	<top_user_menu />
	<div id="main" :class="{ 'main-meeting-page': menuStore().meeting_page }">
		<slot></slot>
	</div>
</template>

<script setup lang="ts">
	import top_user_menu from '../components/menus/top_user_menu.vue';
	import sidebar_menu from '../components/menus/sidebar_menu.vue';
	import sidebar_menu_mobile from '../components/menus/sidebar_menu_mobile.vue';
	import request_photo from '../utils/request_photo';
	import { onMounted } from 'vue';
	import { usePage } from '@inertiajs/vue3';
	import { AuthUser } from 'resources/js/Interfaces/AuthUser';
	import { menuStore } from '../stores/menu';

	function openCloseMenu(menu_is_open) {
		const sidebar = document.getElementById(
			'sidebar-element'
		) as HTMLElement;
		const main = document.getElementById('main') as HTMLElement;

		if (menu_is_open.value) {
			sidebar.style.width = '310px';
			main.style.marginLeft = '310px';
		} else {
			sidebar.style.width = '76px';
			main.style.marginLeft = '76px';
		}
	}

	const is_login = true;
	const auth_user = usePage().props?.auth_user as AuthUser;
	onMounted(() => {
		if (auth_user.user_role === 3) {
			menuStore().addTheRequestForPhotoOnLogout();

			if (!auth_user.student_taken_login_photo) {
				request_photo(is_login);
			}
		}
	});
</script>

<style scoped>
	.sidebar-menu {
		height: 100%;
		width: 310px;
		position: fixed;
		z-index: 1;
		top: 0;
		left: 0;
		overflow-x: hidden;
		transition: 0.3s;
	}

	#main {
		height: 100vh;
		transition: margin-left 0.5s;
		padding: 30px;
		margin-left: 310px;
		background-color: #f2f2f3;
	}

	.main-meeting-page {
		padding: 0px !important;
		height: 92vh !important;
	}

	@media screen and (max-width: 768px) {
		#main {
			margin-left: 0px !important;
		}
	}
</style>
